export default __webpack_public_path__ + "static/media/1896.0c5f66fe.png";